import React from 'react'
import developer from '../../../assets/developer1.png'
import '../../../Styles/about.css'

const About = () => {
    return (
        <div id="about" className="max-w-7xl mx-auto px-10 my-20">
            <h2 class="text-4xl text-center text-warning font-bold">About Me</h2>
            <div className="grid lg:grid-cols-2 gap-y-10 justify-items-center mt-8">
                <div data-aos="fade-left" data-aos-duration="2000">
                    <img width={350} src={developer} alt="Forhad's Pic" />
                </div>
                <div data-aos="fade-right" data-aos-duration="2000" className="my-auto text-success">
                    <h2 className="text-3xl">Hello There!</h2>
                    <p className="my-2">
                        This is your friend Forhad Uddin. Can call me Forhad. I am a Frontend Developer and expert in
                        MERN Stack. Here are some basic info of mine that might be good to know.
                    </p>
                    <div className="grid lg:grid-cols-2 gap-x-10 gap-y-3">
                        <div>
                            <h3 className="text-xl">Name:</h3>
                            <p>Forhad Uddin</p>
                        </div>
                        <div>
                            <h3 className="text-xl">Email:</h3>
                            <p>forhad.uddin164@gmail.com</p>
                        </div>
                        <div>
                            <h3 className="text-xl">Phone:</h3>
                            <p>+880 1682596304</p>
                        </div>
                        <div>
                            <h3 className="text-xl">GitHub:</h3>
                            <a href="https://github.com/forhad-eng" aria-label="Forhad's GitHub">
                                github.com/forhad-eng
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About
